import {Outlook} from '../services/api/fit-api/models/indicators/outlook-info';
import {SvgIcons} from '@ngneat/svg-icon';
import {Palette} from './palette';

export interface OutlookConfig {
	outlook: Outlook;
	sortOrder: number;
	icon: SvgIcons;
	color: Palette;
}

export const OUTLOOKS = [
	{outlook: 'Good', sortOrder: 1, icon: 'done', color: 'green'},
	{outlook: 'Cautionary', sortOrder: 2, icon: 'warning', color: 'orange'},
	{outlook: 'Concerning', sortOrder: 3, icon: 'alert', color: 'red'},
	{outlook: 'Indeterminate', sortOrder: 4, icon: 'no-data', color: 'grey'}
] satisfies Array<OutlookConfig>;
